import { formatDateTime } from '../../../../../../_metronic/helpers/crud-helper/helpers'
import { ProtocoloLinha } from '../../core/_models'

/** "Nome — CRM em data" de quem aprovou; `undefined` se a versão não foi aprovada. */
export const aprovadoPor = (versao: ProtocoloLinha): string | undefined => {
  if (!versao.dtAprovacao) {
    return undefined
  }
  const nome = versao.aprovador?.nome ?? ''
  const crm = versao.crmAprovador ?? ''
  return `${[nome, crm].filter(Boolean).join(' — ')} em ${formatDateTime(versao.dtAprovacao)}`
}

/** De onde a versão nasceu (modelo Lauduz ou outra versão da empresa). */
export const origemDaVersao = (versao: ProtocoloLinha): string | undefined => {
  if (versao.modeloOrigem) {
    return `Criado a partir do modelo Lauduz v${versao.modeloOrigem.versao}`
  }
  if (versao.protocoloOrigem) {
    return `Criado a partir da versão ${versao.protocoloOrigem.versao}`
  }
  return undefined
}
